import React from 'react';

const Disclaimer = () => {
    return (
        <div style={{ padding: '20px', lineHeight: '1.6', margin: '0 auto' }}>
            <h1 style={{ textAlign: 'center', marginBottom: '20px', marginTop: "110px", color: "#cc9051" }}>Disclaimer</h1>

            <p>Welcome to <strong>TULIKA.com</strong>. By accessing and browsing this website, you agree to the following terms and conditions.</p>

            <h4>Limitation of Liability</h4>
            <ul>
                <li>Use or reliance on information provided on this website.</li>
                <li>Any errors or omissions in website content.</li>
                <li>Unauthorized use or reproduction of artwork images.</li>
                <li>Technical issues or website downtime.</li>
            </ul>

            <h4>Copyright and Intellectual Property</h4>
            <p>
                All artwork images, designs, and content on this website are copyrighted and owned by <strong>TULIKA.com</strong>
                and/or its respective artists. Any unauthorized use, reproduction, or distribution is strictly prohibited.
            </p>

            <h4>Color Variations</h4>
            <p>Due to screen resolution and color variations, actual painting colors may differ from website representations.</p>

            <h4>Artwork Availability and Pricing</h4>
            <p>Artwork availability and pricing are subject to change without notice.</p>

            <h4>User-Generated Content</h4>
            <p>
                By submitting comments, feedback, or artwork to this website, you grant <strong>TULIKA.com</strong> non-exclusive,
                royalty-free rights to use and display such content.
            </p>

            <h4>Third-Party Links</h4>
            <p>
                This website may contain links to external websites. <strong>TULIKA.com</strong> is not responsible for the content,
                accuracy, or policies of any external website.
            </p>

            <h4>Changes to Disclaimer</h4>
            <p>We reserve the right to modify or update this disclaimer at any time without notice.</p>

            <h2>Contact</h2>
            <p>
                For questions or concerns regarding this disclaimer, please contact us at
                <a href="mailto:tulikartsworks@gmail.com" style={{ marginLeft: '5px' }}>tulikartsworks@gmail.com</a> or call
                <a href="tel:+91986926077" style={{ marginLeft: '5px' }}>+91 9869261077</a>.
            </p>
        </div>
    );
};

export default Disclaimer;
